(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaq(root) {
    if (root.dataset.bkFaqReady === '1') return;
    root.dataset.bkFaqReady = '1';

    var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tablist = root.querySelector('[data-bk-faq-tablist]');
    var tabs = tablist ? Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]')) : [];
    var sections = Array.prototype.slice.call(root.querySelectorAll('.bk-faq__section'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-bk-faq-item]'));
    var searchInput = root.querySelector('[data-bk-faq-search]');
    var clearBtns = Array.prototype.slice.call(root.querySelectorAll('[data-bk-faq-clear]'));
    var emptyEl = root.querySelector('[data-bk-faq-empty]');
    var statusEl = root.querySelector('[data-bk-faq-status]');

    var activeCat = 'all';
    var query = '';

    /* Pre-index each item's searchable text (question + answer, lowercased). */
    items.forEach(function (item) {
      var q = item.querySelector('.bk-faq__q-text');
      var a = item.querySelector('.bk-faq__a-inner');
      item._bkText = ((q ? q.textContent : '') + ' ' + (a ? a.textContent : '')).toLowerCase();
    });

    /* ---- Accordion a11y: aria-expanded sync (§2.1) ---- */
    items.forEach(function (item) {
      var summary = item.querySelector('.bk-faq__q');
      item.addEventListener('toggle', function () {
        if (summary) summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
      });
    });
    /* Esc dismisses the open panel, focus back to its summary (WCAG 1.4.13) */
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var open = root.querySelector('.bk-faq__item[open]');
      if (open && (open.contains(document.activeElement) || document.activeElement === document.body)) {
        open.open = false;
        var s = open.querySelector('.bk-faq__q');
        if (s) s.focus();
      }
    });

    function closeAllOpen() {
      root.querySelectorAll('.bk-faq__item[open]').forEach(function (i) { i.open = false; });
    }

    /* ---- Filtering ---- */
    function applyFilter() {
      var q = query.trim().toLowerCase();
      var totalVisible = 0;

      items.forEach(function (item) {
        var matchQuery = !q || item._bkText.indexOf(q) > -1;
        item.hidden = !matchQuery;
        if (matchQuery) totalVisible++;
      });

      sections.forEach(function (sec) {
        var inCat = (activeCat === 'all') || (sec.dataset.category === activeCat);
        var hasVisible = sec.querySelectorAll('.bk-faq__item:not([hidden])').length > 0;
        sec.hidden = !(inCat && hasVisible);
      });

      if (emptyEl) emptyEl.hidden = !(q && totalVisible === 0);

      if (statusEl) {
        if (q) statusEl.textContent = totalVisible + (totalVisible === 1 ? ' result' : ' results') + ' for "' + query.trim() + '"';
        else statusEl.textContent = '';
      }
    }

    /* ---- Tabs (§2.2 ARIA tablist) ---- */
    function selectTab(tab, focusIt) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on) t.setAttribute('aria-current', 'page'); else t.removeAttribute('aria-current');
      });
      activeCat = tab.dataset.cat;
      /* selecting a category clears any active search (browse mode) */
      if (searchInput && searchInput.value) { searchInput.value = ''; query = ''; updateClear(); }
      applyFilter();
      if (focusIt) tab.focus();
      /* mobile: bring active pill into view */
      try { tab.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', inline: 'center', block: 'nearest' }); } catch (e) {}
      /* URL hash via replaceState (§2.5) — preserve query string */
      var base = location.pathname + location.search;
      try { history.replaceState(null, '', activeCat === 'all' ? base : base + '#' + activeCat); } catch (e) {}
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { selectTab(tab, false); });
    });
    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var next = -1;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next > -1) { e.preventDefault(); selectTab(tabs[next], true); }   /* automatic activation */
      });
    }

    /* ---- Search (§2.4 debounced + clear) ---- */
    function updateClear() {
      clearBtns.forEach(function (b) {
        if (b.classList.contains('bk-faq__search-clear')) b.hidden = !(searchInput && searchInput.value);
      });
    }
    function resetToAll() {
      var allTab = tabs.filter(function (t) { return t.dataset.cat === 'all'; })[0];
      tabs.forEach(function (t) {
        var on = t === allTab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on) t.setAttribute('aria-current', 'page'); else t.removeAttribute('aria-current');
      });
      activeCat = 'all';
    }
    if (searchInput) {
      var t = null;
      searchInput.addEventListener('input', function () {
        updateClear();
        clearTimeout(t);
        t = setTimeout(function () {
          query = searchInput.value;
          if (query.trim()) resetToAll();   /* search is global — overlay/v2 */
          applyFilter();
        }, 130);
      });
    }
    clearBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (searchInput) { searchInput.value = ''; }
        query = '';
        updateClear();
        closeAllOpen();
        resetToAll();
        applyFilter();
        if (searchInput) searchInput.focus();
      });
    });

    /* ---- URL hash on load (§2.5) ---- */
    function activateFromHash() {
      var h = (location.hash || '').replace('#', '');
      if (!h) return;
      var match = tabs.filter(function (t) { return t.dataset.cat === h; })[0];
      if (match) {
        selectTab(match, false);
        try { match.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', inline: 'center', block: 'nearest' }); } catch (e) {}
        var panel = root.querySelector('.bk-faq__section[data-category="' + h + '"]');
        if (panel) { try { panel.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' }); } catch (e) {} }
      }
    }

    applyFilter();
    updateClear();
    activateFromHash();
  }

  function boot() { document.querySelectorAll('[data-bk-faq]').forEach(initFaq); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-hp-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bindAtc(form) {
    if (form.dataset.bkAtcReady === '1') return;
    form.dataset.bkAtcReady = '1';
    var btn = form.querySelector('[data-bk-atc-btn]');
    form.addEventListener('submit', function (e) {
      if (!btn) return;
      e.preventDefault();
      var defaultLabel = btn.getAttribute('data-default-label') || btn.textContent;
      var successLabel = btn.getAttribute('data-success-label') || 'Added';
      btn.disabled = true;
      btn.textContent = 'AddingÃ¢â‚¬Â¦';
      var fd = new FormData(form);
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          btn.textContent = successLabel;
          btn.dataset.state = 'success';
          // Dispatch events the parent theme / cart drawer may listen for
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:add', { bubbles: true }));
          window.dispatchEvent(new CustomEvent('cart:updated'));
          // Update cart count bubble if present
          fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count, cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
                el.setAttribute('data-count', cart.item_count);
              });
            })
            .catch(function () {});
          setTimeout(function () {
            btn.textContent = defaultLabel;
            btn.removeAttribute('data-state');
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          // Fallback to native form submission
          btn.disabled = false;
          btn.textContent = defaultLabel;
          form.submit();
        });
    });
  }
  /* PL2 Phase 1: carousel arrow controller.
     - Desktop only (CSS hides on <1024). The JS still binds on mobile but
       all clicks are blocked because the buttons are display:none.
     - scrollBy(card_width + gap) on click, smooth behaviour.
     - Listens to scroll + resize (debounced) to toggle [hidden] on the
       prev/next buttons when at start/end.
     - Defensive against missing children + idempotent (data-flag). */
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function bindCarousel(wrap) {
    if (wrap.dataset.bkCarouselReady === '1') return;
    wrap.dataset.bkCarouselReady = '1';
    var grid = wrap.querySelector('[data-bk-bestsellers-grid]');
    var prev = wrap.querySelector('[data-bk-bestsellers-prev]');
    var next = wrap.querySelector('[data-bk-bestsellers-next]');
    if (!grid || !prev || !next) return;

    function step() {
      var card = grid.querySelector('.bk-hp-bestsellers__card-wrap, .bk-hp-bestsellers__card');
      if (!card) return 320;     /* sensible fallback */
      var cs = window.getComputedStyle(grid);
      var gap = parseFloat(cs.columnGap || cs.gap || '24') || 24;
      return card.getBoundingClientRect().width + gap;
    }
    function updateNav() {
      var max = grid.scrollWidth - grid.clientWidth;
      var atStart = grid.scrollLeft <= 1;
      var atEnd = grid.scrollLeft >= max - 4;
      if (atStart) prev.setAttribute('hidden', '');
      else prev.removeAttribute('hidden');
      if (atEnd) next.setAttribute('hidden', '');
      else next.removeAttribute('hidden');
    }
    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      grid.scrollBy({ left: step(), behavior: 'smooth' });
    });
    grid.addEventListener('scroll', debounce(updateNav, 80), { passive: true });
    window.addEventListener('resize', debounce(updateNav, 120));
    updateNav();
  }

  function init() {
    document.querySelectorAll('[data-bk-atc]').forEach(bindAtc);
    document.querySelectorAll('[data-bk-bestsellers-carousel]').forEach(bindCarousel);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-hp-hero-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bindAtc(form) {
    if (form.dataset.bkAtcReady === '1') return;
    form.dataset.bkAtcReady = '1';
    var btn = form.querySelector('[data-bk-atc-btn]');
    form.addEventListener('submit', function (e) {
      if (!btn) return;
      e.preventDefault();
      var defaultLabel = btn.getAttribute('data-default-label') || btn.textContent;
      var successLabel = btn.getAttribute('data-success-label') || 'Added';
      btn.disabled = true;
      btn.textContent = 'AddingÃ¢â‚¬Â¦';
      var fd = new FormData(form);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          btn.textContent = successLabel;
          btn.dataset.state = 'success';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:add', { bubbles: true }));
          window.dispatchEvent(new CustomEvent('cart:updated'));
          fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count, cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
                el.setAttribute('data-count', cart.item_count);
              });
            })
            .catch(function () {});
          setTimeout(function () {
            btn.textContent = defaultLabel;
            btn.removeAttribute('data-state');
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = defaultLabel;
          form.submit();
        });
    });
  }
  function init() {
    document.querySelectorAll('.bk-hp-hero-product [data-bk-atc]').forEach(bindAtc);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-hp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initScrollIndicator(root) {
    var btn = root.querySelector('[data-bk-scroll]');
    if (!btn || btn.dataset.bkScrollReady === '1') return;
    btn.dataset.bkScrollReady = '1';
    btn.addEventListener('click', function () {
      var custom = btn.getAttribute('data-bk-scroll-target');
      var target = null;
      if (custom) {
        try { target = document.querySelector(custom); } catch (e) { target = null; }
      }
      if (!target) {
        // Default: scroll to the next sibling section element
        var hostSection = root.closest('.shopify-section') || root;
        var next = hostSection.nextElementSibling;
        while (next && (next.offsetHeight === 0 || next.getAttribute('hidden') !== null && next.hasAttribute('hidden'))) {
          next = next.nextElementSibling;
        }
        target = next;
      }
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollBy({ top: window.innerHeight * 0.9, behavior: 'smooth' });
      }
    });
  }

  function initHero(root) {
    initScrollIndicator(root);

    if (root.dataset.bkHeroReady === '1') return;
    root.dataset.bkHeroReady = '1';

    var slideCount = Number(root.dataset.bkSlideCount || 0);
    if (slideCount < 2) return; // single banner mode — no JS needed

    var slides = root.querySelectorAll('.bk-hp-hero__slide');
    var dots = root.querySelectorAll('[data-bk-dot]');
    var prev = root.querySelector('[data-bk-prev]');
    var next = root.querySelector('[data-bk-next]');
    var current = 0;
    var autoplayMs = Number(root.dataset.bkAutoplay || 0) * 1000;
    var timer = null;

    function go(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      current = index;
    }

    function nextSlide() { go(current + 1); }
    function prevSlide() { go(current - 1); }

    if (prev) prev.addEventListener('click', function () { prevSlide(); restartAutoplay(); });
    if (next) next.addEventListener('click', function () { nextSlide(); restartAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(Number(dot.dataset.bkDot)); restartAutoplay();
      });
    });

    function startAutoplay() {
      if (!autoplayMs) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(nextSlide, autoplayMs);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    // Touch swipe
    var touchStartX = null;
    root.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches.length === 1) touchStartX = e.touches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchStartX == null) return;
      var endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : null;
      if (endX != null) {
        var dx = endX - touchStartX;
        if (Math.abs(dx) > 50) {
          if (dx < 0) { nextSlide(); } else { prevSlide(); }
          restartAutoplay();
        }
      }
      touchStartX = null;
    }, { passive: true });

    startAutoplay();
  }

  function bootstrap(scope) {
    (scope || document).querySelectorAll('[data-bk-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-hp-topbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTopbar(el) {
    if (el.dataset.bkTopbarReady === '1') return;
    el.dataset.bkTopbarReady = '1';

    var count = parseInt(el.dataset.count, 10) || 0;
    if (count <= 1) return;

    var interval = parseInt(el.dataset.interval, 10) || 4000;
    var msgs = el.querySelectorAll('.bk-hp-topbar__msg');
    if (msgs.length <= 1) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var idx = 0;
    var timer = null;

    function show(nextIdx) {
      msgs.forEach(function (m, i) {
        var active = i === nextIdx;
        m.classList.toggle('is-active', active);
        if (active) {
          m.removeAttribute('aria-hidden');
          if (m.tagName === 'A') m.removeAttribute('tabindex');
        } else {
          m.setAttribute('aria-hidden', 'true');
          if (m.tagName === 'A') m.setAttribute('tabindex', '-1');
        }
      });
    }

    function tick() {
      idx = (idx + 1) % msgs.length;
      show(idx);
    }

    function start() {
      stop();
      timer = window.setInterval(tick, interval);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    start();
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);

    // Re-init in theme editor block selection
    document.addEventListener('shopify:section:load', function () {});
  }

  function bootstrap() {
    document.querySelectorAll('[data-bk-topbar]').forEach(initTopbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-bk-topbar]') : null;
    if (el) initTopbar(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-hp-trending"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSoundToggle(btn) {
    if (btn.dataset.bkSoundReady === '1') return;
    btn.dataset.bkSoundReady = '1';
    var media = btn.closest('.bk-hp-trending__media');
    if (!media) return;
    var video = media.querySelector('[data-bk-video]');
    if (!video) return;
    btn.addEventListener('click', function () {
      var nextMuted = !video.muted ? true : false;
      video.muted = nextMuted;
      btn.setAttribute('aria-pressed', nextMuted ? 'false' : 'true');
      // Pause other videos when unmuting one to avoid overlapping audio
      if (!nextMuted) {
        document.querySelectorAll('.bk-hp-trending [data-bk-video]').forEach(function (v) {
          if (v !== video) { v.muted = true; }
        });
        document.querySelectorAll('.bk-hp-trending [data-bk-sound-toggle]').forEach(function (b) {
          if (b !== btn) { b.setAttribute('aria-pressed', 'false'); }
        });
      }
    });
  }

  function initAutoplay(video) {
    if (!video || video.dataset.bkAutoplayReady === '1') return;
    video.dataset.bkAutoplayReady = '1';
    // IntersectionObserver: play when in view, pause when out
    if (!('IntersectionObserver' in window)) {
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var p = video.play();
          if (p && typeof p.catch === 'function') { p.catch(function () {}); }
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 });
    io.observe(video);
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : '';
  }

  function refreshEurusSections(parsedState) {
    // Eurus exposes the sections to re-render via Alpine.store('xCartHelper').
    // After a successful add we patch each section's innerHTML in place so
    // the cart drawer, mini cart, cart icon bubble and free-shipping bar
    // all reflect the new state without a full page reload.
    if (!window.Alpine) return;
    var helper = window.Alpine.store && window.Alpine.store('xCartHelper');
    if (!helper || typeof helper.getSectionsToRender !== 'function') return;
    var sections = helper.getSectionsToRender();
    if (!sections || !parsedState || !parsedState.sections) return;
    sections.forEach(function (section) {
      var el = document.querySelector(section.selector);
      if (el && parsedState.sections[section.id]) {
        try {
          el.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        } catch (e) { /* swallow */ }
      }
    });
    // Update the bubble count from the freshly rendered DOM.
    var bubble = document.querySelector('#cart-icon-bubble span');
    if (bubble) {
      var n = parseInt(bubble.innerHTML, 10);
      if (!isNaN(n)) { helper.currentItemCount = n; }
    } else if (typeof parsedState.item_count === 'number') {
      helper.currentItemCount = parsedState.item_count;
    }
  }

  function openEurusMiniCart() {
    if (!window.Alpine || !window.Alpine.store) return false;
    var miniCart = window.Alpine.store('xMiniCart');
    if (miniCart && typeof miniCart.openCart === 'function') {
      miniCart.openCart();
      return true;
    }
    return false;
  }

  function initAtc(btn) {
    if (btn.dataset.bkAtcReady === '1') return;
    btn.dataset.bkAtcReady = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      var fallbackUrl = btn.getAttribute('data-product-url');
      if (!variantId || variantId === '0') {
        if (fallbackUrl) { window.location.href = fallbackUrl; }
        return;
      }
      if (btn.getAttribute('data-bk-state') === 'loading') return;
      btn.setAttribute('data-bk-state', 'loading');

      // Match Eurus's product-cart.js payload: single item, with `sections`
      // so the drawer can be patched in place from the response.
      var sectionsToRender = [];
      if (window.Alpine && window.Alpine.store) {
        var helper = window.Alpine.store('xCartHelper');
        if (helper && typeof helper.getSectionsToRender === 'function') {
          sectionsToRender = helper.getSectionsToRender().map(function (s) { return s.id; });
        }
      }

      var rootRoute = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(rootRoute + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          sections: sectionsToRender,
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (err) {
              throw new Error((err && (err.description || err.message)) || ('Add to cart failed: ' + r.status));
            }).catch(function () { throw new Error('Add to cart failed: ' + r.status); });
          }
          return r.json();
        })
        .then(function (parsedState) {
          btn.setAttribute('data-bk-state', 'done');
          refreshEurusSections(parsedState);
          // Notify other Eurus listeners (free-shipping bar etc.)
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          // Open the Eurus mini-cart drawer; fall back to clicking the cart
          // icon if the Alpine store isn't available.
          setTimeout(function () {
            if (!openEurusMiniCart()) {
              var cartIcon = document.querySelector('#cart-icon, [data-cart-icon], .header__icon--cart');
              if (cartIcon && typeof cartIcon.click === 'function') { cartIcon.click(); }
            }
          }, 200);
          // Reset visual state after 2.5s so the button is usable again.
          setTimeout(function () {
            if (btn.getAttribute('data-bk-state') === 'done') {
              btn.removeAttribute('data-bk-state');
            }
          }, 2500);
        })
        .catch(function (err) {
          console.error('[bk-hp-trending] ATC failed:', err);
          btn.removeAttribute('data-bk-state');
          // Visible error flash so the user knows the click registered.
          btn.setAttribute('data-bk-state', 'error');
          setTimeout(function () { btn.removeAttribute('data-bk-state'); }, 1800);
        });
    });
  }

  function bootstrap(root) {
    var scope = root || document;
    scope.querySelectorAll('.bk-hp-trending [data-bk-sound-toggle]').forEach(initSoundToggle);
    scope.querySelectorAll('.bk-hp-trending [data-bk-video][autoplay]').forEach(initAutoplay);
    scope.querySelectorAll('.bk-hp-trending [data-bk-atc]').forEach(initAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-rrm-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bindFaq(root) {
    if (root.dataset.bkFaqReady === '1') return;
    root.dataset.bkFaqReady = '1';
    var items = root.querySelectorAll('.bk-rrm-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var summary = item.querySelector('.bk-rrm-faq__q');
      /* sync aria-expanded with native open state */
      item.addEventListener('toggle', function () {
        if (summary) summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
      });
    });

    /* Esc dismisses the open panel (WCAG 1.4.13). Return focus to its summary. */
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var open = root.querySelector('.bk-rrm-faq__item[open]');
      if (open) {
        open.open = false;
        var s = open.querySelector('.bk-rrm-faq__q');
        if (s) s.focus();
      }
    });
  }
  function init() { document.querySelectorAll('[data-bk-faq]').forEach(bindFaq); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-rrm-press"] && !Shopify.designMode) return;
  try {
    
(function () {
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function bindPress(wrap) {
    if (wrap.dataset.bkPressReady === '1') return;
    wrap.dataset.bkPressReady = '1';
    var track = wrap.querySelector('[data-bk-press-track]');
    var prev = wrap.querySelector('[data-bk-press-prev]');
    var next = wrap.querySelector('[data-bk-press-next]');
    if (!track) return;
    var slides = track.querySelectorAll('.bk-rrm-press__slide');
    if (!slides.length) return;

    /* PL2: scrollBy(cardWidth + gap), toggle [hidden] at start/end */
    function step() {
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }
    function updateNav() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft <= 1) prev.setAttribute('hidden', '');
      else prev.removeAttribute('hidden');
      if (track.scrollLeft >= max - 4) next.setAttribute('hidden', '');
      else next.removeAttribute('hidden');
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    /* v5 position dots */
    var dotsWrap = wrap.parentNode.querySelector('[data-bk-press-dots]');
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bk-rrm-press__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to quote ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }
    function updateDots() {
      if (!dots.length) return;
      var w = slides[0].offsetWidth || 1;
      var active = Math.round(track.scrollLeft / w);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
    }

    track.addEventListener('scroll', debounce(function () { updateNav(); updateDots(); }, 80), { passive: true });
    window.addEventListener('resize', debounce(updateNav, 120));
    updateNav();
  }
  function init() {
    document.querySelectorAll('[data-bk-press-carousel]').forEach(bindPress);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-rrm-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bindSticky(bar) {
    if (bar.dataset.bkStickyReady === '1') return;
    bar.dataset.bkStickyReady = '1';

    var hero = document.querySelector('[id^="bk-rrm-hero-"]');
    var finalCta = document.querySelector('[id^="bk-rrm-final-cta-"]');

    /* Reserve body space so the bar never obscures the footer / last content.
       Re-measured on resize because the bar height differs by breakpoint. */
    function reserve() {
      if (window.getComputedStyle(bar).display === 'none') {
        document.body.style.paddingBottom = '';
        return;
      }
      document.body.style.paddingBottom = bar.offsetHeight + 'px';
    }

    var heroOut = false;     /* scrolled past hero */
    var ctaIn = false;       /* final-cta visible */
    function apply() {
      var show = heroOut && !ctaIn;
      bar.classList.toggle('is-visible', show);
    }

    if ('IntersectionObserver' in window) {
      if (hero) {
        /* reveal once the hero has fully scrolled out of view (threshold 0) */
        new IntersectionObserver(function (entries) {
          heroOut = !entries[0].isIntersecting;
          apply();
        }, { threshold: 0 }).observe(hero);
      } else {
        heroOut = true;  /* no hero found → reveal after first scroll */
      }
      if (finalCta) {
        new IntersectionObserver(function (entries) {
          ctaIn = entries[0].isIntersecting;
          apply();
        }, { threshold: 0.01 }).observe(finalCta);
      }
    } else {
      /* fallback: simple scroll threshold */
      window.addEventListener('scroll', function () {
        heroOut = window.scrollY > (window.innerHeight * 0.6);
        apply();
      }, { passive: true });
    }

    reserve();
    window.addEventListener('resize', reserve);
    /* re-measure once fonts/images settle */
    window.addEventListener('load', reserve);
    apply();
  }
  function init() { document.querySelectorAll('[data-bk-sticky]').forEach(bindSticky); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-rrm-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bindStory(root) {
    if (root.dataset.bkStoryReady === '1') return;
    root.dataset.bkStoryReady = '1';
    var modal = root.querySelector('[data-bk-story-modal]');
    var frame = root.querySelector('[data-bk-story-frame]');
    if (!modal || !frame) return;
    var openers = root.querySelectorAll('[data-bk-story-open]');
    var closeBtn = root.querySelector('[data-bk-story-close]');

    function buildEmbedUrl(url) {
      if (!url) return '';
      var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/);
      if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
      var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
      return url; /* assume already an embeddable URL */
    }
    function mount() {
      if (frame.dataset.mounted === '1') return;
      var type = frame.getAttribute('data-video-type');
      if (type === 'shopify') {
        var tpl = frame.querySelector('[data-bk-story-source]');
        if (tpl && tpl.content) frame.appendChild(tpl.content.cloneNode(true));
      } else {
        var src = buildEmbedUrl(frame.getAttribute('data-video-url'));
        if (src) {
          var iframe = document.createElement('iframe');
          iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', modal.getAttribute('aria-label') || 'Video');
          iframe.src = src;
          frame.appendChild(iframe);
        }
      }
      frame.dataset.mounted = '1';
    }
    function unmount() {
      /* stop playback + free bandwidth on close */
      var media = frame.querySelectorAll('iframe, video');
      media.forEach(function (m) { if (m.tagName === 'VIDEO') { try { m.pause(); } catch (e) {} } m.remove(); });
      frame.dataset.mounted = '';
    }
    function open(e) {
      if (e) e.preventDefault();
      mount();
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
    }
    function close() {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
    }
    openers.forEach(function (o) { o.addEventListener('click', open); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    /* click on backdrop closes */
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    /* native dialog fires 'close' on Esc — clean up the embed then */
    modal.addEventListener('close', unmount);
  }
  function init() { document.querySelectorAll('[data-bk-story]').forEach(bindStory); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
